import React, { useContext, useState } from "react";
import { MasterConfigContext } from "@/context/MasterConfigContext";
import { useWindowSize } from "@/hooks/useIsMobile";
import { useRouter } from "next/router";
const CandidateProfile = ({
  electionPassedCategory = "",
  masterKey = "",
  candidateProfileData = null,
  candidateList = null,
}) => {
  const masterConfig = useContext(MasterConfigContext);
  const electionKeys = masterConfig[masterKey];
  const showCandidateProfile = electionKeys?.showCandidateProfile;
  const keyCandiShowArrow = electionKeys?.keyCandiShowArrow;
  const election_year = electionKeys?.constDetailYear;

  //  console.log("candidateProfileData 12", candidateProfileData);

  const { width: screenWidth } = useWindowSize();
  const router = useRouter();
  const isDelhi = router?.asPath.includes("delhi");
  const isBihar = router?.asPath.includes("bihar");
  const isMaharashtra = router?.asPath.includes("maharashtra");
  const isHaryana = router?.asPath.includes("haryana");
  const isJharkhand = router?.asPath.includes("jharkhand");
  const [readMore, setReadMore] = useState(true);
  function extractCount(text) {
  const match = text?.match(/\d+/);
  return match ? Number(match[0]) : 0;
}
  const content = `${candidateProfileData?.candidate_h} ${candidateList?.constituency_name_h} विधानसभा चुनाव ${election_year} में ${candidateProfileData?.party_h} के उम्मीदवार हैं.
 ये ${candidateList?.constituency_name_h} विधानसभा सीट से चुनाव लड़ रहे हैं.
     ${candidateProfileData?.age} वर्षीय ${candidateProfileData?.candidate_h} ने  ${candidateProfileData?.qualification} की है
   इनकी कुल संपत्ति ₹ ${candidateProfileData?.income} है. इनके ऊपर ₹ ${candidateProfileData?.liabilities} की देनदारी है. इनके ऊपर आपराधिक मामले ${candidateProfileData?.criminal_cases == "No" ? "नहीं" : extractCount(candidateProfileData?.criminal_cases)} हैं. `

  return candidateProfileData ? (
    <div className="mx-2 my-2">
      <div className="flex items-center">
        <span className={`w-[5px] h-[45px] md:h-[30px] ${isBihar ? "bg-[#CF4C9B]" : 'bg-primary'}`}></span>
        <h1 className="text-xl font-bold ml-2">
          {/* {candidateProfileData?.candidate_h} Election Result {election_year}{" "}
          {candidateList?.constituency_name} */}
          {candidateProfileData?.candidate_h} {candidateList?.constituency_name_h} विधानसभा रिजल्ट {election_year}
        </h1>
      </div>

      {/* Profile Section */}
      <div className="shadow-md rounded-md mt-3">
        <div className=" hidden md:block shadow-md rounded-md mt-3 bg-gradient-to-b from-white to-blue-100 border">
          <div className="flex items-start p-4">
            {/* Profile Image */}
            <div className="w-20 h-20 min-w-[80px] bg-gray-200 rounded-full overflow-hidden flex items-center justify-center">
              {candidateProfileData?.image ? (
                <img
                  className="w-full h-full object-cover"
                  alt="candidate"
                  src={candidateProfileData?.image}
                />
              ) : (
                <img
                  className="w-full h-full object-cover"
                  alt="candidate"
                  src={"https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/Candidate.svg"}
                />
              )}
            </div>

            {/* Candidate Details */}

            <div className="flex flex-1 ml-4 flex-col">
              {/* Top Row */}
              <div className="flex justify-between items-start">
                {/* Candidate Name */}
                <h2 className="text-[22px] font-bold text-gray-800">
                  {candidateProfileData?.candidate_h}
                </h2>

                {/* Party + Status */}
                <div className="flex items-center gap-3">
                  <div className="p-2 rounded-md flex items-center bg-[#FEE5D2]">
                    {candidateProfileData?.party_h}
                    <img
                      className="ml-2 rounded-full"
                      width={25}
                      height={25}
                      alt="partylogo"
                      src={candidateProfileData?.party_logo}
                    />
                  </div>

                  {keyCandiShowArrow ? <p className=" font-semibold flex items-center">
                    {candidateProfileData?.status === "WON" ? (
                      <p className="flex items-center text-green-500">
                        {" "}
                        <img
                          width={20}
                          height={20}
                          src={
                            "https://akm-img-a-in.tosshub.com/sites/electiontak/images/won.png"
                          }
                          alt="Live Icon"
                        />{" "}
                        <span className="ml-1 mt-1"> जीत</span>{" "}
                      </p>
                    ) : candidateProfileData?.status === "LEADING" ? (
                      <p className="flex items-center text-black-500 justify-center">
                        <img
                          width={20}
                          height={20}
                          src="https://akm-img-a-in.tosshub.com/lingo/nwtak/resources/arrow-up.png"
                          alt="Live Icon"
                        />
                        <span className="ml-1">आगे</span>
                      </p>
                    ) : candidateProfileData?.status === "Result Awaited" ? (
                      <p className="flex items-center text-black-500 justify-center">
                        <img
                          width={20}
                          height={20}
                          src="https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/liveIcon.gif"
                          alt="Live Icon"
                        />
                        <span className="ml-1">Result Awaited</span>
                      </p>
                    ) : candidateProfileData?.status === "TRAILING" ? (
                      <p className="flex items-center text-black-500 justify-center">
                        <img
                          width={20}
                          height={20}
                          src="https://akm-img-a-in.tosshub.com/lingo/nwtak/resources/arrow-down.png"
                          alt="Live Icon"
                        />
                        <span className="ml-1">पीछे</span>
                      </p>
                    ) : (
                      <p className="flex items-center text-primary justify-center">
                        <img
                          width={20}
                          height={20}
                          src="https://akm-img-a-in.tosshub.com/sites/electiontak/images/lost.png"
                          alt="Live Icon"
                        />
                        <span className="ml-1">हार</span>
                      </p>

                    )}

                    {!candidateProfileData?.status === "Result Awaited" && (
                      <span className="ml-2">
                        <img
                          className="bg-gradient-to-b to-blue-100"
                          width={15}
                          height={15}
                          alt="partylogo"
                          src={
                            candidateProfileData?.status === "LEADING"
                              ? "https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/up-arrow.png"
                              : candidateProfileData?.status_logo
                          }
                        />
                      </span>
                    )}
                  </p> : <p className="font-semibold flex items-center">
                    <img
                      width={20}
                      height={20}
                      src="https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/liveIcon.gif"
                      alt="Live Icon"
                    />
                    <span className="ml-1">Result Awaited</span>
                  </p>}
                </div>
              </div>


              <p className="text-[15px] leading-7 text-gray-700 mt-2  border-t-[1px]">
                <div
                  className={`${readMore ? "line-clamp-2" : ""}`}

                > {content} </div>
                <span
                  onClick={() => {
                    setReadMore((prev) => !prev);
                  }}
                  className="cursor-pointer inline ml-[5px]  text-primary text-sm"
                >
                  {readMore ? "और देखें >" : "< कम देखें"}
                </span>
              </p>
            </div>
          </div>
        </div>
        {/* mobile */}
        <div className="block md:hidden shadow-md rounded-md mt-3 bg-gradient-to-b from-white to-blue-100 border overflow-hidden">
          <div className="p-4">
            {/* Top section */}
            <div className="flex items-start gap-3">
              {/* Profile Image */}
              <div className="w-20 h-20 min-w-[80px] rounded-full overflow-hidden bg-gray-200 flex items-center justify-center">
                {candidateProfileData?.image ? (
                  <img
                    className="w-full h-full object-cover"
                    alt="candidate"
                    src={candidateProfileData?.image}
                  />
                ) : (
                   <img
                  className="w-full h-full object-cover"
                  alt="candidate"
                  src={"https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/Candidate.svg"}
                />
                )}
              </div>

              {/* Right Side */}
              <div className="flex-1 min-w-0">
                {/* Candidate Name */}
                <h2 className="text-[18px] sm:text-[22px] font-bold text-gray-800 leading-6">
                  {candidateProfileData?.candidate_h}
                </h2>

                {/* Party + Status */}
                <div className="flex flex-wrap items-center gap-2 mt-2">
                  <div className="px-2 py-1 rounded-md flex items-center bg-[#FEE5D2] text-sm font-medium">
                    {candidateProfileData?.party_h}
                    <img
                      className="ml-2 rounded-full"
                      width={20}
                      height={20}
                      alt="partylogo"
                      src={candidateProfileData?.party_logo}
                    />
                  </div>

                  {/* Status */}
                  {keyCandiShowArrow ? <p className=" font-semibold flex items-center">
                    {candidateProfileData?.status === "WON" ? (
                      <p className="flex items-center text-green-500">
                        {" "}
                        <img
                          width={20}
                          height={20}
                          src={
                            "https://akm-img-a-in.tosshub.com/sites/electiontak/images/won.png"
                          }
                          alt="Live Icon"
                        />{" "}
                        <span className="ml-1 mt-1"> जीत</span>{" "}
                      </p>
                    ) : candidateProfileData?.status === "LEADING" ? (
                      <p className="flex items-center text-black-500 justify-center">
                        <img
                          width={20}
                          height={20}
                          src="https://akm-img-a-in.tosshub.com/lingo/nwtak/resources/arrow-up.png"
                          alt="Live Icon"
                        />
                        <span className="ml-1">आगे</span>
                      </p>
                    ) : candidateProfileData?.status === "Result Awaited" ? (
                      <p className="flex items-center text-black-500 justify-center">
                        <img
                          width={20}
                          height={20}
                          src="https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/liveIcon.gif"
                          alt="Live Icon"
                        />
                        <span className="ml-1">Result Awaited</span>
                      </p>
                    ) : candidateProfileData?.status === "TRAILING" ? (
                      <p className="flex items-center text-black-500 justify-center">
                        <img
                          width={20}
                          height={20}
                          src="https://akm-img-a-in.tosshub.com/lingo/nwtak/resources/arrow-down.png"
                          alt="Live Icon"
                        />
                        <span className="ml-1">पीछे</span>
                      </p>
                    ) : (
                      <p className="flex items-center text-primary justify-center">
                        <img
                          width={20}
                          height={20}
                          src="https://akm-img-a-in.tosshub.com/sites/electiontak/images/lost.png"
                          alt="Live Icon"
                        />
                        <span className="ml-1">हार</span>
                      </p>

                    )}

                    {!candidateProfileData?.status === "Result Awaited" && (
                      <span className="ml-2">
                        <img
                          className="bg-gradient-to-b to-blue-100"
                          width={15}
                          height={15}
                          alt="partylogo"
                          src={
                            candidateProfileData?.status === "LEADING"
                              ? "https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/up-arrow.png"
                              : candidateProfileData?.status_logo
                          }
                        />
                      </span>
                    )}
                  </p> : <p className="font-semibold flex items-center">
                    <img
                      width={20}
                      height={20}
                      src="https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/liveIcon.gif"
                      alt="Live Icon"
                    />
                    <span className="ml-1">Result Awaited</span>
                  </p>}
                </div>
              </div>
            </div>

            {/* Content */}
            <p className="text-[15px] leading-7 text-gray-700 mt-2  border-t-[1px]">
              <div
                className={`${readMore ? "line-clamp-2" : ""}`}

              > {content} </div>
              <span
                onClick={() => {
                  setReadMore((prev) => !prev);
                }}
                className="cursor-pointer inline ml-[5px]  text-primary text-sm"
              >
                {readMore ? "और देखें >" : "< कम देखें"}
              </span>
            </p>
          </div>
        </div>



        {/* Details Table */}
        <div className="overflow-x-auto bg-white shadow-md">
          <table className="w-full text-sm text-gray-700">
            <tbody>
              {/* Row 1 */}
              <tr className="border-b flex flex-wrap md:table-row">
                <td className="py-3 px-2  font-bold w-1/2 md:w-[20%]">आयु</td>
                <td className="py-3 px-2 w-1/2 md:w-[30%]">
                  {candidateProfileData?.age} वर्ष
                </td>
                <td className="py-3 px-2 font-bold w-1/2 md:w-[20%]">वोट</td>
                <td className="py-3 px-2 w-1/2 md:w-[30%]">
                  {keyCandiShowArrow ? candidateProfileData?.votes : "-"}{" "}
                </td>
              </tr>
              {/* Row 2 */}
              <tr className="border-b flex flex-wrap md:table-row">
                <td className="py-3 px-2 font-bold w-1/2 md:w-[15%]">लिंग</td>
                <td className="py-3 px-2 w-1/2 md:w-[35%]">
                  {["M", "MALE", "Male", "male"].includes(
                    candidateProfileData?.gender
                  )
                    ? "पुरुष"
                    : ["F", "FEMALE", "Female", "female"].includes(
                      candidateProfileData?.gender
                    )
                      ? "महिला"
                      : candidateProfileData?.gender}{" "}
                </td>
                <td className="py-3 px-2 font-bold w-1/2 md:w-[15%]">
                  संपत्ति
                </td>
                <td className="py-3 px-2 w-1/2 md:w-[35%]">
                  {candidateProfileData?.assets && `₹ ${candidateProfileData?.assets}`}
                </td>
              </tr>
              {/* Row 3 */}
              <tr className="border-b flex flex-wrap md:table-row">
                <td className="py-3 px-2 font-bold w-1/2 md:w-[15%]">
                  शैक्षिक योग्यता
                </td>
                <td className="py-3 px-2 w-1/2 md:w-[35%]">
                  {" "}
                  {candidateProfileData?.qualification}
                </td>
                <td className="py-3 px-2 font-bold w-1/2 md:w-[15%]">
                  कुल आय
                </td>
                <td className="py-3 px-2 w-1/2 md:w-[35%]">
                  {candidateProfileData?.income && `₹ ${candidateProfileData?.income}`}
                </td>
              </tr>
              {/* Row 4 */}
              <tr className="border-b flex flex-wrap md:table-row">
                <td className="py-3 px-2 font-bold w-1/2 md:w-auto">
                  प्रोफेशनल व्यवसाय
                </td>
                <td className="py-3 px-2 w-1/2 md:w-auto">
                  {candidateProfileData?.profession}{" "}
                </td>
                <td className="py-3 px-2 font-bold w-1/2 md:w-auto">
                  अचल संपत्ति
                </td>
                <td className="py-3 px-2 w-1/2 md:w-auto">
                  {candidateProfileData?.immovable_assets && `₹ ${candidateProfileData?.immovable_assets}`}
                </td>
              </tr>
              {/* Row 5 */}
              <tr className="border-b flex flex-wrap md:table-row">
                <td className="py-3 px-2 font-bold w-1/2 md:w-auto">
                  आपराधिक मामले
                </td>
                <td className="py-3 px-2 w-1/2 md:w-auto">
                  {extractCount(candidateProfileData?.criminal_cases)}{" "}
                </td>
                <td className="py-3 px-2 font-bold w-1/2 md:w-auto">
                  निर्वाचन क्षेत्र
                </td>
                <td className="py-3 px-2 w-1/2 md:w-auto">
                  {candidateList?.constituency_name_h || candidateList?.constituency_name}{" "}
                </td>
              </tr>
              {/* Row 6 */}
              <tr className="flex flex-wrap md:table-row">
                <td className="py-3 px-2 font-bold w-1/2 md:w-auto">
                  देनदारियां
                </td>
                <td className="py-3 px-2 w-1/2 md:w-auto">
                  {candidateProfileData?.liabilities && `₹ ${candidateProfileData?.liabilities}`}
                </td>
                <td className="py-3 px-2 font-bold w-1/2 md:w-auto">
                  चल संपत्ति
                </td>
                <td className="py-3 px-2 w-1/2 md:w-auto">
                  {candidateProfileData?.moveable_assets && `₹ ${candidateProfileData?.moveable_assets}`}{" "}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      {/* Related Candidates Section */}
      <div className="bg-white shadow-md rounded-md p-2 my-1">
        <div className="flex justify-between items-center">
          <div className="flex items-center ">
            {/* Vertical line */}
            <span className={`  ${isBihar ? "bg-[#CF4C9B]" : 'bg-primary'} w-[5px] h-[30px]  inline-block mr-1`}></span>
            <h2 className=" font-bold  text-[20px]">
              {candidateList?.constituency_name?.charAt(0).toUpperCase() + candidateList?.constituency_name?.slice(1)?.toLowerCase()} Constituency Candidates Names

            </h2>
          </div>

          {/* Link */}
          <a
            className={` ${isBihar ? "text-[#CF4C9B]" : 'text-primary'} text-sm font-medium whitespace-nowrap `}
            href={`${process?.env?.NEXT_PUBLIC_WEBSITE_URL}/elections/${electionPassedCategory}/constituency-list`}
          >
            और देखें &gt;
          </a>
        </div>

        <div
          className={`flex gap-4 overflow-x-auto mt-4`} // Flex layout with horizontal scroll
          style={{
            paddingBottom: "1rem", // Extra padding for better scroll spacing
          }}
        >
          {candidateList?.candidate
            ?.filter(
              (can) =>
                can?.id !== candidateProfileData?.id &&
                can?.candidate !== "NOTA" &&
                can?.candidate !== "Nota" &&
                can?.candidate !== "nota"
            )
            // ?.slice(0, screenWidth < 768 ? 4 : candidateList?.candidate?.length) // Show up to 5 cards on desktop
            ?.map((can, index) => (
              <div
                onClick={
                  () =>
                  (window.location.href = `${process?.env?.NEXT_PUBLIC_WEBSITE_URL
                    }/elections/${electionPassedCategory}/candidates/${can?.candidate

                      ?.toLowerCase()
                      .replace(/[^a-zA-Z ]/g, "")
                      .split(" ")
                      .join("-")}-result-${candidateList?.constituency_name
                        ?.toLowerCase()
                        .replace(/[^a-zA-Z ]/g, "")
                        .split(" ")
                        .join("-")}-${candidateList?.id}-${can?.id}`) //use candidate id
                }
                key={index}
                className="  flex flex-col items-center bg-gradient-to-b to-blue-100 from-white p-4 rounded-md shadow-sm"
                style={{
                  cursor: "pointer",
                  flexShrink: 0, // Prevent shrinking for scrolling
                  width: screenWidth >= 768 ? "25%" : "45%", // Adjust card width based on screen size
                }}
              >
                <div className="w-20 h-20 bg-gray-200 rounded-full flex justify-center items-center text-gray-500 overflow-hidden">
                  {can?.image ? (
                    <img
                      className="w-full h-full rounded-full object-cover"
                      alt="partylogo"
                      src={can?.image}
                    />
                  ) : (
                    <img
                      className="w-full h-full rounded-full object-cover"
                      alt="partylogo"
                     src={"https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/Candidate.svg"}
                    />
                  )}
                </div>
                 <div className="text-center">
                  {" "}
                  <p className={`mt-2 text-sm underline font-medium    ${isBihar ? "hover:text-[#CF4C9B]" : 'hover:text-primary '} `}>
                    {can?.candidate_h}
                  </p>
                  <p className="text-sm text-gray-600">{can?.party_h}</p>
                </div>
              </div>
            ))}
        </div>
      </div>
      {/* ADR START */}
      <div
        onClick={() => window.open("https://adrindia.org/", "_blank")}
        style={{
          display: "flex",
          justifyContent: "center",
          gap: "40px",
          marginTop: "20px",
          marginBottom: "20px",
          cursor: "pointer",
        }}
      >
        <div>
          {" "}
          <img src="https://akm-img-a-in.tosshub.com/lingo/nwtak/resources/adr_logo.png" />{" "}
        </div>
        <div>
          <img src="https://akm-img-a-in.tosshub.com/lingo/nwtak/resources/mynetainfo.png" />{" "}
        </div>
        <div className="hover:underline">
          Association for Democratic Reforms (ADR) | MyNeta.info.
        </div>
      </div>
      {/* ADR END */}
    </div>
  ) : (
    <div className="text-center"> No data found</div>
  );
};

export default CandidateProfile;
